export default __webpack_public_path__ + "static/water-a9535a365c3f60e7da7f8de9653961d9.mp4";